// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_17xwd8PKexr9rLfc_aKdjn","shareBlock":"-COg7IvFyYbxiVXvobHlF","shareWrapper":"_2uxf9p04MiZwtmyOwWLx_b","shareOpenWrapper":"_3_Z-L53tmRAgj9t101Qkhy","shareTitle":"_3jwYdPHjwW26Cz-xnfj5IA","companySocialIcons":"_3H604qe6iqDw9k_YsbSHV","realtorsAssociation":"_1DG-aY0w68NLYhA5L0n0fQ","shareRow":"_2wCO_2O5_UkgC7e0QJZhdw","iconWrapper":"_3tASoP_3VDW6bznCcsww5S","shareIcon":"_7CL1LScJsJk9ZYZjfgGnc","phoneNative":"_1Mu5YDMpYZ-FiIlKLANK-c","copyLink":"_2Z3Kh7KTJEe7eXk36h0H9K","copyLinkWrap":"_3xABzzky97MYcjA-0Rprjw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ShareButtonsRow/ShareButtonsRow.scss
// module id = 1776
// module chunks = 0